// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"16707f4d","977":"5873eb2c"}[chunkId] + ".chunk.js";
};